export const deliverabilityPostmasterAppGroupIdLatestEvent =
  "/deliverability/postmaster/:app_group_id/latest_event";
